import { User } from "kreate-common/modules/business-types";
import { z } from "zod";

export const Params = z.object({
  searchQuery: z.string().optional(),
  excludeUsersWithNoArtworks: z
    .enum(["true", "false"])
    .transform((value) => value === "true")
    .optional(),
  offset: z.coerce.number(),
  isVerified: z
    .enum(["true", "false"])
    .transform((value) => value === "true")
    .optional(),
  limit: z.coerce.number(),
  numMaxArtworks: z.coerce.number(),
  orderBy: z.union([z.literal("new"), z.literal("popular")]).optional(),
});

export type Params = z.infer<typeof Params>;

export const Result = z.object({
  users: User.array(),
  count: z.number().nullish(),
});

export type Result = z.infer<typeof Result>;

export type GetUserList$Params = Params;
export const GetUserList$Params = Params;
export type GetUserList$Result = Result;
export const GetUserList$Result = Result;
